export const UPDATE_MOVEMENT = 'UPDATE_MOVEMENT';
export const DELETE_MOVEMENT = 'DELETE_MOVEMENT';
export const CREATE_MOVEMENT = 'CREATE_MOVEMENT';
export const GET_MOVEMENTS = 'GET_MOVEMENTS';